import { render, staticRenderFns } from "./PatientProfile.vue?vue&type=template&id=673f49b5&scoped=true"
import script from "./PatientProfile.vue?vue&type=script&lang=js"
export * from "./PatientProfile.vue?vue&type=script&lang=js"
import style0 from "./PatientProfile.scss?vue&type=style&index=0&id=673f49b5&prod&lang=scss&scoped=true&external"
import style1 from "../Followups/patient-profile-followups.scss?vue&type=style&index=1&id=673f49b5&prod&lang=scss&scoped=true&external"
import style2 from "./PatientProfile.vue?vue&type=style&index=2&id=673f49b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f49b5",
  null
  
)

export default component.exports